export default __webpack_public_path__ + "static/media/Function_Categories.db5815ed.svg";